import { useState } from "react";
import { getIcon } from "@utils/jsxHelpers";
import { useSurveyStore } from "@src/store/survey";
import { Heading, Flex, Text, Card } from "@radix-ui/themes";
import { useEffect } from "react";
import PropTypes from "prop-types";
import { useLingui } from "@lingui/react";

MapCommentQuestion.propTypes = {
  question: PropTypes.object,
};

/**
 * This component is for the sidebar button component the user clicks in order to.
 * comment on the map. The component for the comment is in the MapComment component.
 **/
export default function MapCommentQuestion({ question }) {
  const commentQuestion = useSurveyStore((state) => state.commentQuestion);
  const setCommentQuestion = useSurveyStore(
    (state) => state.setCommentQuestion,
  );
  const [isActive, setIsActive] = useState(false);
  const { i18n } = useLingui();

  useEffect(() => {
    setIsActive(
      commentQuestion !== undefined && commentQuestion?.uuid === question.uuid,
    );
  }, [commentQuestion, question]);

  useEffect(() => {
    if (commentQuestion?.uuid == question?.uuid) {
      setCommentQuestion(question);
    }
  }, [i18n.locale, question, commentQuestion, setCommentQuestion]);

  const handleClick = (e) => {
    e.preventDefault();
    if (commentQuestion === undefined) {
      setCommentQuestion(question);
    } else if (
      commentQuestion !== undefined &&
      commentQuestion?.uuid !== question.uuid
    ) {
      setCommentQuestion(question);
    } else {
      setCommentQuestion();
    }
  };

  return (
    <Card
      asChild
      color={question.options?.color ? question.options.color : "gray"}
      style={{ cursor: "pointer" }}
      onClick={handleClick}
      className={`map-comment-button ${isActive ? "active" : ""}`}
      as="a"
      href="#"
      tabIndex="0"
    >
      <div>
        <Flex gap="3" align="baseline">
          <div style={{ textAlign: "left" }}>
            {getIcon(question.options.icon)}
          </div>
          <Heading as="h3" size="3">
            {question.question}
          </Heading>
        </Flex>
        {question.hint_text && (
          <Text as="p" size="1" color="gray" mt="1">
            {question.hint_text}
          </Text>
        )}
      </div>
    </Card>
  );
}
